


































import { Component, Vue, Prop } from 'vue-property-decorator'
import SettingsCard from '@/components/WorkspaceSettings/SettingsCard.vue'
import AjaxButton, { AjaxButtonType } from '@/components/AjaxButton.vue'
import ConfirmationMessage from '@/components/WorkspaceSettings/ConfirmationMessage.vue'
import { Checkbox } from '@alpha/ink'
import LogoUpload from './LogoUpload.vue'
import { SettingsSubmissionData, SettingsSubmissionResponse, SettingsConfirmation } from '@/views/WorkspaceSettings.vue'

@Component({
  name: 'IconSettings',
  components: { AjaxButton, ConfirmationMessage, SettingsCard, Checkbox, LogoUpload }
})
export default class IconSettings extends Vue {
  @Prop({ required: false }) logo!: string| null

  icon:string| null = this.logo
  confirmation: SettingsConfirmation = {
    status: false,
    msg: ''
  }

  submitting: boolean = false

  submit () {
    if (!this.submitting) {
      this.confirmation.status = false
      this.submitting = true
      const submitObj: SettingsSubmissionData = {
        component: this,
        section: 'workspaceInfo',
        data: {
          status: 'success',
          icon: this.icon
        }
      }
      this.$emit('submit', submitObj)
    }
  }

  uploadLogo ($event: string | null) {
    if ($event) {
      this.icon = $event
    }
  }

  finish (confirmation: SettingsSubmissionResponse) {
    const that = this
    this.confirmation = confirmation
    this.submitting = false
    const ref = this.$refs.saveButton as AjaxButtonType
    ref.finish()
    if (confirmation.status !== 'failure') {
      setTimeout(function () {
        that.$set(that.confirmation, 'status', false)
      }, 3000)
    }
  }
}
